/**
 * Transform single API response to chart format
 * @param {Object} apiData - Single API response object
 * @returns {Object} Transformed data for charts
 */
export function transformSingleOpenClickData(apiData) {
  if (!apiData || !apiData.created_at) {
    return {
      labels: [],
      opened: [],
      clicked: [],
      bounced: []
    };
  }
  
  const date = new Date(apiData.created_at);
  const label = date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric' 
  });
  
  return {
    labels: [label],
    opened: [apiData.opens || apiData.unique_opens || 0],
    clicked: [apiData.clicks || apiData.unique_clicks || 0],
    bounced: [apiData.bounces || 0]
  };
}

/**
 * Transform array of API responses to chart format
 * @param {Array} apiData - Array of API response objects
 * @returns {Object} Transformed data for charts
 */
export function transformOpenClickDataArray(apiData) {
  if (!Array.isArray(apiData) || apiData.length === 0) {
    return {
      labels: [],
      opened: [],
      clicked: [],
      bounced: []
    };
  }
  
  const labels = [];
  const opened = [];
  const clicked = [];
  const bounced = [];
  
  apiData.forEach(item => {
    const date = new Date(item.created_at);
    labels.push(date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric' 
    }));
    
    opened.push(item.opens || item.unique_opens || 0);
    clicked.push(item.clicks || item.unique_clicks || 0);
    bounced.push(item.bounces || 0);
  });
  
  return {
    labels,
    opened,
    clicked,
    bounced
  };
} 